// 共用圖表元件 (recharts)
import React from 'react';

export { money } from './api.js';
import { money } from './api.js';

export function ChartTip({ active, payload, label }) {
  if (!active || !payload || !payload.length) return null;
  return (
    <div className="glass-tooltip">
      {label !== undefined ? <div className="tt-title">{label}</div> : null}
      {payload.map((p, i) => (
        <div key={i} className="tt-row">
          <span className="tt-dot" style={{ background: p.color || p.fill }} />
          <span>{p.name}:</span>
          <span className="money-value" style={{ color: 'var(--ink)' }}>HK$ {money(p.value)}</span>
        </div>
      ))}
    </div>
  );
}

export const CHART_COLORS = ['#ededed', '#a8a8a8', '#747474', '#d0d0d0', '#909090', '#bcbcbc'];

export function Legend({ items }) {
  return (
    <div className="row" style={{ gap: 14 }}>
      {items.map((it, i) => (
        <span key={i} className="legend-chip"><span className="d" style={{ background: it.c }} />{it.t}</span>
      ))}
    </div>
  );
}
